var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-full",
    viewBox: "0 0 38 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2322 51.7678C18.2085 52.7441 19.7915 52.7441 20.7678 51.7678L36.6777 35.8579C37.654 34.8816 37.654 33.2986 36.6777 32.3223C35.7014 31.346 34.1184 31.346 33.1421 32.3223L19 46.4645L4.85787 32.3223C3.88155 31.346 2.29864 31.346 1.32233 32.3223C0.346021 33.2986 0.346021 34.8816 1.32233 35.8579L17.2322 51.7678ZM16.5 11L16.5 50L21.5 50L21.5 11L16.5 11Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a1754031d6f584ce3ed3e85433c28a5f.svg";
export { ForwardRef as ReactComponent };